module.exports = __webpack_public_path__ + "static/media/edit.304289d7.svg";